module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--huge-405eef823aceb4096b2d5713981de8fb.jpg";